module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "go-back-container"
  }, [_c('div', {
    staticClass: "go-back-icon",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons white--text"
  }, [_vm._v("arrow_back_ios")])])]), _vm._v(" "), (_vm.currentLocation !== 'Worldwide') ? _c('div', {
    staticClass: "filterLocationContainer"
  }, [_c('div', {
    staticClass: "filterLocation"
  }, [_c('pre', [_vm._v(_vm._s(_vm.currentLocation) + ", ")]), _vm._v(" "), _c('pre', {
    staticClass: "logo-color"
  }, [_vm._v("with")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../static/img/logo-purple.svg"),
      "alt": "logo",
      "height": "12px"
    }
  }), _vm._v(" "), _c('pre', {
    staticClass: "logo-color"
  }, [_vm._v("view")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: ("blur-it-" + (_vm.$store.state.common.swichModesBG)),
    staticStyle: {
      "background": "black",
      "position": "relative"
    },
    style: (_vm.isChild ? '' : 'height: 100vh'),
    on: {
      "click": function($event) {
        _vm.$store.state.common.swichModesBG ? _vm.$store.state.common.swichModesBG = false : ''
      }
    }
  }, [_c('v-btn', {
    staticStyle: {
      "bottom": "19em",
      "right": "0.2em",
      "height": "4.5em",
      "width": "4.5em"
    },
    attrs: {
      "fab": "",
      "fixed": ""
    },
    on: {
      "click": _vm.goToUserCurrentLoc
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("my_location")])]), _vm._v(" "), _c('div', {
    staticClass: "div-width-100",
    style: (_vm.isChild ? 'height: 450px' : ("height: " + _vm.mapH + "px")),
    attrs: {
      "id": "map"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "scroll-view",
    attrs: {
      "id": "scroll-hor"
    }
  }, _vm._l((_vm.dummyPoints.photos), function(image, i) {
    return _c('div', {
      key: i,
      staticClass: "image-cards",
      attrs: {
        "id": ("image-" + (image.id))
      }
    }, [(!_vm.isChild) ? _c('v-icon', {
      staticClass: "fav-icon",
      style: (image.isLiked ? {
        color: '#ff0000'
      } : {
        color: '#ffffff'
      }),
      on: {
        "click": function($event) {
          return _vm.changeCnt(i)
        }
      }
    }, [_vm._v("favorite")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "above-img",
      style: (("borderBottom: " + (_vm.selectedImg === image.id ? '2px solid rgb(189, 16, 224)' : 'none')))
    }), _vm._v(" "), _c('div', {
      on: {
        "click": function($event) {
          _vm.$router.push({
            path: ("/id/" + (image.id) + "?inapp=true")
          });
          _vm.saveInLocatStorage(i)
        }
      }
    }, [_c('v-lazy-image', {
      staticClass: "main-img pointer",
      attrs: {
        "src": _vm.mapViewImage(image.id, image)
      }
    })], 1), _vm._v(" "), (!_vm.isChild) ? _c('div', {
      staticStyle: {
        "display": "flex",
        "justify-content": "space-between",
        "align-items": "center"
      }
    }, [_c('div', {
      staticClass: "name pointer",
      style: (image.uploader === 'admin' ? {
        color: '#9b9b9b'
      } : 'color: #9b9b9b'),
      on: {
        "click": function($event) {
          image.uploader !== 'admin' ?
            _vm.saveInLocatStorage(i) : '';
          image.uploader !== 'admin' ?
            _vm.$router.push({
              path: '/profile',
              query: {
                uploader: image.uploader,
                profile_id: image.mediaSourceInformation.photoGrapherId,
                selected_tab: 'checkins'
              }
            }) : ''
        }
      }
    }, [_vm._v(_vm._s(_vm.cropUsername(image.mediaSourceInformation.photoGrapherName)) + " ©")]), _vm._v(" "), _c('div', {
      staticClass: "dist",
      on: {
        "click": function($event) {
          image.distance.includes('--') ? _vm.$modal.show('location-modal') : _vm.goToImageDetMap({
            caption: image.caption === '' ? 'n' : image.caption,
            image: image
          })
        }
      }
    }, [(!_vm.fetchLocLoader) ? _c('v-icon', {
      staticClass: "material-icons",
      staticStyle: {
        "color": "#9b9b9b"
      }
    }, [_vm._v("near_me")]) : _c('i', {
      staticClass: "fa fa-spinner fa-spin fa-x fa-fw",
      staticStyle: {
        "color": "#2c3e50"
      }
    }), _vm._v(" "), (!_vm.fetchLocLoader) ? _c('div', {
      staticClass: "dist-text white--text"
    }, [_vm._v(_vm._s(image.distance))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "caption",
      staticStyle: {
        "max-width": "220px"
      }
    }, [_vm._v(_vm._s(image.caption))])], 1)
  }), 0), _vm._v(" "), (!_vm.isChild) ? _c('div', {
    staticClass: "footer"
  }, [_c('img', {
    staticClass: "pointer",
    attrs: {
      "height": "16",
      "src": require("../../static/img/wav-icon.png")
    },
    on: {
      "click": function($event) {
        return _vm.goToHome(_vm.screenW > 600 ? false : true)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "material-icons pointer",
    on: {
      "click": _vm.goToUpload
    }
  }, [_vm._v("photo_camera")]), _vm._v(" "), (!_vm.isLoggedIn) ? _c('i', {
    staticClass: "material-icons pointer",
    on: {
      "click": function($event) {
        _vm.isLoggedIn ? _vm.$router.push({
          path: '/profile',
          query: {
            uploader: 'user',
            profile_Id: _vm.user.uid,
            selected_tab: 'checkins'
          }
        }) : _vm.$router.push("/login")
      }
    }
  }, [_vm._v("perm_identity")]) : _c('img', {
    staticClass: "pointer",
    staticStyle: {
      "height": "1.5em",
      "width": "1.5em",
      "border-radius": "100%"
    },
    attrs: {
      "src": _vm.user.photoURL
    },
    on: {
      "click": function($event) {
        _vm.isLoggedIn ? _vm.$router.push({
          path: '/profile',
          query: {
            uploader: 'user',
            profile_id: _vm.user.uid,
            selected_tab: 'checkins'
          }
        }) : _vm.$router.push("/login")
      }
    }
  })]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-031cc83a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mapView.vue
// module id = 597
// module chunks = 2 7